import BrandInformationForm from "../Outlet/components/BrandInfoForm";
import Dropdown from "../../components/dropdown/Index";
import useMallTenantDropdown from "../../hooks/useMallTenantDropdown";

export default function VendorDetail() {
  const {
    mallOptions,
    tenantOptions,
    brandOptions,
    selectedMall,
    selectedTenant,
    selectedBrand,
    setSelectedMall,
    setSelectedTenant,
    setSelectedBrand,
  } = useMallTenantDropdown();

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <div className="p-4 sm:p-6 space-y-4 sm:space-y-6">
        <Dropdown
          mallSelected={setSelectedMall}
          mallOptions={mallOptions}
          tenantSelected={setSelectedTenant}
          tenantOptions={tenantOptions}
          mallValue={selectedMall}
          tenantValue={selectedTenant}
          brandSelected={setSelectedBrand}
          brandOptions={brandOptions}
          brandValue={selectedBrand}
        />

        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700">
          <BrandInformationForm tenantId={selectedTenant} brandId={0} />
        </div>
      </div>
    </div>
  );
}
